// Randomized carousel
document.querySelectorAll('section.randomized').forEach(section =>
{
	const list = section.querySelector('.collection-list');

	if (list)
	{
		const temp = list.cloneNode(true);
		for (let i = temp.children.length + 1; i--;)
		{
			temp.appendChild(temp.children[Math.random() * i | 0]);
		}

		list.parentNode.replaceChild(temp, list);
	}
});